import { useAppSelector } from 'app';

/**
 * Returns true when the current session is an Aspen DMS user on a hosted dealer.
 * Used to gate features that should only apply to Aspen hosted dealers.
 */
export const useIsAspenHostedDealer = (): boolean => {
  const isHostedDealer = useAppSelector((state) => state.user.isHosted);
  return isHostedDealer && localStorage.getItem('Login_Source')?.toString() === 'DMS_ASPEN';
};

export default useIsAspenHostedDealer;
